import React from 'react';
import type { CustodyCase } from '../../types/case';
import type { AdminPage, AdminPageProps } from '../../types/navigation';
import { useStore } from '../../contexts/StoreContext';
import { PageHeader } from '../../components/admin/PageHeader';
import { StatusBadge } from '../../components/shared/StatusBadge';
import { ADMIN_MENU } from '../../components/admin/AdminSidebar';
import { isPaid, needsVerification, readyForNote, stageInfo } from '../../utils/caseStatus';
import { bn, fmtDate } from '../../utils/bn';
const FILTERS: Partial<Record<AdminPage, (c: CustodyCase) => boolean>> = {
  verification: needsVerification,
  payments: c => c.stage !== 'registered' && (!isPaid(c) || c.paymentStatus === 'paid'),
  notesheet: c => readyForNote(c) || c.approval === 'pending',
  letters: c => c.approval === 'approved' || !!c.letter,
  handover: c => !!c.letter && (c.letter.status === 'issued' || c.letter.status === 'redeemed')
};

/** Interim queue view: lists the cases relevant to a workflow module and opens their full case record. */
export function WorkQueue({
  page,
  openCase
}: AdminPageProps & {
  page: AdminPage;
}) {
  const {
    cases
  } = useStore();
  const title = ADMIN_MENU.find(m => m.id === page)?.label ?? '';
  const list = cases.filter(FILTERS[page] ?? (() => true));
  return <>
      <PageHeader title={title} crumbs={[title]} description={`${bn(list.length)}টি সংশ্লিষ্ট কেস — বিস্তারিত ও ইতিহাসের জন্য কেস খুলুন`} data-id="element-1505" data-mp="1w8l490bkji7" />
      <div className="card divide-y divide-line" data-id="element-1506" data-mp="5v7xufsalkk7">
        {list.map(c => {
        const s = stageInfo(c);
        return <button key={c.pcr} onClick={() => openCase(c.pcr)} className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left hover:bg-navy-50" data-id="element-1507" data-mp="fmc3upzzpv2w">
              <span className="min-w-0" data-id="element-1508" data-mp="knt0uafcsxe7">
                <span className="block font-mono text-sm font-semibold text-navy" data-id="element-1509" data-mp="plukawgoyyq7">{c.pcr}</span>
                <span className="block truncate text-xs text-ink-muted" data-id="element-1510" data-mp="tlv8v9xi8qaz">{c.regNo} · {c.ownerName} · {fmtDate(c.createdAt)}</span>
              </span>
              <StatusBadge size="sm" label={s.label} tone={s.tone} data-id="element-1511" data-mp="2ql6gw2odimh4" />
            </button>;
      })}
        {list.length === 0 && <p className="py-12 text-center text-sm text-ink-muted" data-id="element-1512" data-mp="2zfci4a11olng">এই মুহূর্তে কোনো কেস নেই।</p>}
      </div>
    </>;
}